<template>
  <base-block-tmp
    class="recipe-card"
    :class="{ 'is-selected': isSelected, 'is-in-modal': insideModal, 'is-select-type': isSelectType }"
    type="recipe"
    :size="size"
    :url="recipe.url"
    :layout-type="layoutType"
    :small-card-type="smallCardType || insideModal"
    :label-text="`Recept ${recipe.title}, ${recipe.cookingTime}, betyg ${recipeRating.averageRating} av 5. ${recipeRating.numberOfVotes} röster.`"
    @simulateClick="simulateClickOnLink"
  >
    <template #content>
      <div class="recipe-card__content">
        <epi-property
          id="RecipeId"
          :icon-only="true"
        />
        <component
          :is="isSelectType ? 'div' : 'a'"
          ref="linkref"
          :href="isSelectType ? null : recipe.url"
          :target="isSelectType ? null : linkTarget"
          aria-label="Recept"
          class="recipe-card__content__title font-rubrik-2--mid"
          @click.stop="isSelectType ? null : $emit('is-clicked') "
        >
          {{ recipe.title }}
        </component>
        <div class="recipe-card__content__attr">
          <div class="recipe-card__content__attr__rating">
            <ica-rating
              :average-rating="recipeRating.averageRating"
              :votes="recipeRating.numberOfVotes"
              :size="20"
              :user-rated="userRating"
              :show-user-rate="showUserRate"
            />
          </div>

          <!--

            TEST WITOUT THESE EXTRA ATTRIBUTES

            <div class="recipe-card__content__attr__comments">
            <svgicon class="recipe-card__content__attr__icon" name="Communication/Comment" />
            <span class="recipe-card__content__attr__comments--text">
              {{ recipe.numberOfComments || 0 }}
            </span>
          </div>
          <div
            v-if="recipe.isGoodClimateChoice"
            aria-label="Bra klimatval"
            class="recipe-card__content__attr__climate"
          >
            <svgicon class="recipe-card__content__attr__icon" name="Climate/ClimateGuide" />
            <span v-if="showClimateText" class="recipe-card__content__attr__climate--text">Klimatsmart</span>
          </div>

          <div v-if="recipe.isKeyHole" aria-label="Nyckelhålsmärkt">
            <svgicon
              class="recipe-card__content__attr__icon"
              :original="true"
              name="ProductMarks/Nyckelhalsmarkning"
            />
          </div> -->
        </div>

        <div
          v-if="($root.isMediumViewport && isSize.full) || ($root.isLargeViewport && isSize.full)"
          class="recipe-card__content__preamble"
        >
          {{ recipe.preamble }}
        </div>
      </div>
    </template>

    <template #media>
      <ica-save-recipe-button
        v-if="!hideSaveButton && !isSelectType"
        v-model="isSavedInner"
        :user-rated="recipe.userRating"
        :button-size="40"
      />

      <menu-button
        :aria-label="`recept ${recipe.title}`"
        :button-size="40"
      >
        <button
          class="button button--transparent button--40 button--text-icon menu-button-content"
          @click="openAddToFolderModal()"
        >
          <svgicon name="Cooking/RecipeCollection" />
          Lägg till i samling
        </button>
        <slot
          name="menu"
          @click="scope.toggle()"
        />

        <button
          class="button button--transparent button--40 button--text-icon menu-button-content"
          @click="shareRecipe(recipe)"
        >
          <svgicon name="Controls/Share" />
          Dela recept
        </button>
      </menu-button>
      <cloudinary-picture
        :url="imageUrl"
        :sizes="dimensions"
        :sharpen="80"
        auto-quality="best"
        :use-picture="false"
        :aspect-ratio="aspectRatio"
        :alt="recipe.title"
        :scroll-container-id="scrollContainerId"
      />
    </template>

    <template #footer>
      <recipe-card-meta
        :cooking-time="recipe.cookingTime"
        :number-of-ingredients="recipe.numberOfIngredients"
        :difficulty="recipe.difficulty"
        :inside-modal="insideModal"
        :block-size="size"
      />
    </template>
  </base-block-tmp>
</template>

<script>
import CloudinaryPicture from '../common/picture/cloudinaryPicture.vue'
import BaseBlockTmp, { layoutTypes } from './BaseBlockComponent'
import { IcaSaveRecipeButton, IcaRating } from '~/@ica/ica-molecules-vue/src/components'
import svgicon from 'vue-svgicon'
import '#/Communication/Comment'
import '#/Climate/ClimateGuide'
import '#/Shop/Coupon'
import '#/Controls/Share'
import '#/Cooking/RecipeCollection'
import '#/ProductMarks/Nyckelhalsmarkning'
import MenuButton from './MenuButton'
import RecipeCardMeta from './RecipeCardMeta.vue'
import datalayer from '../../../analytics/dataLayer'

export default {
  name: 'RecipeCard',
  components: {
    BaseBlockTmp,
    IcaSaveRecipeButton,
    IcaRating,
    CloudinaryPicture,
    svgicon,
    MenuButton,
    RecipeCardMeta,
  },
  props: {
    blockSize: {
      type: String,
      default: 'quarter',
      validator (value) {
        return ['full', 'half', 'third', 'quarter'].includes(value)
      },
    },
    recipe: {
      type: Object,
      default: () => {},
    },
    isSaved: {
      type: Boolean,
      default: false,
    },
    showUserRate: {
      type: Boolean,
      default: false,
    },
    hideSaveButton: {
      type: Boolean,
      default: false,
    },
    dimensions: {
      type: Object,
      default: () => ({
        small: {
          width: 480,
        },
        medium: {
          width: 480,
        },
        large: {
          width: 570,
        },
      }),
    },
    linkTarget: {
      type: String,
      default: null,
    },
    insideModal: {
      type: Boolean,
      default: false,
    },
    smallCardType: {
      type: Boolean,
      default: false,
    },
    isSelectType: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    scrollContainerId: {
      type: String,
      default: null,
    },
    ssrAsSize: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      recipeIsSaved: false,
      isMounted: false,
    }
  },
  computed: {
    recipeRating () {
      return (
        this.recipe.rating || {
          averageRating: 0,
          numberOfVotes: 0,
        }
      )
    },
    userRating () {
      return this.recipe.customerRating || this.recipe.userRating || 0
    },
    imageUrl () {
      const r = this.recipe
      if (r.imageUrl) {
        return r.imageUrl
      } else if (r.images && r.images.length) {
        for (let i = 0; i < r.images.length; i++) {
          if (r.images[i].size === 'default') {
            return r.images[i].url
          }
        }
        return r.images[0].url
      }
      return ''
    },
    size () {
      return this.isEditable ? 'full' : this.blockSize
    },
    isSavedInner: {
      get () {
        return this.isSaved
      },
      set (newValue) {
        this.$emit('is-saved', newValue)
      },
    },
    isSelectedInner: {
      get () {
        return this.isSelected
      },
      set (newValue) {
        this.$emit('is-selected', newValue)
      },
    },
    isSize () {
      return {
        [this.size]: true,
      }
    },
    aspectRatio () {
      if (this.isSize.full) {
        return this.$root.currentSizeLte('md') ? 0 : 78
      }
      return this.$root.isSmallViewport ? 100 : 0
    },
    layoutType () {
      const size = !this.isMounted && this.ssrAsSize ? this.ssrAsSize : this.$root.currentSize
      switch (size) {
        case 'sm':
        case 'xs':
        case 'xxs':
          return this.isSize.full ? layoutTypes.mediaTop : layoutTypes.mediaRightSmall
        default:
          return this.isSize.full ? layoutTypes.mediaLeft : layoutTypes.mediaTop
      }
    },
    showClimateText () {
      if (this.insideModal) {return false}
      switch (this.size) {
        case 'full':
          return true
        case 'half':
          return this.$root.currentSizeGte('sm')
        case 'third':
        case 'quarter':
        default:
          return this.$root.currentSizeEquals('sm')
      }
    },
  },
  mounted () {
    this.isMounted = true
  },
  methods: {
    simulateClickOnLink () {
      if (this.isSelectType) {
        this.isSelectedInner = !this.isSelectedInner
      }
      this.$refs.linkref.click()
    },
    widthBetween (a, b) {
      return this.$root.windowWidth >= a && this.$root.windowWidth < b
    },
    shareRecipe (recipe) {
      if (navigator.share && location) {
        navigator.share({
          title: recipe.title,
          url: window.location.origin + recipe.url,
        })
      } else {
        // fallback om native delning inte fungerar

        // copy url to clipboard
        const input = this.$refs.copyUrlToClipBoard
        if (input) {
          input.value = window.location.origin + recipe.url
          input.select()
          input.setSelectionRange(0, input.value.length)
          document.execCommand('copy')
        }
      }

      this.shareRecipeTracking(recipe)
    },
    shareRecipeTracking (recipe) {
      datalayer.add({
        event: 'recipeShare',
        recipeId: recipe.id,
        recipeName: recipe.title,
        linkName: recipe.title,
        linkUrl: window.location.origin + recipe.url,
      })
    },
    openAddToFolderModal () {
      this.$emit('open-folder-modal', {
        id: this.recipe.id, title: this.recipe.title
      })
    },
  },
}
</script>

<style lang="scss">
.recipe-card {
  $base: &;

  // SPECIAL STATE
  &.is-in-modal {
    border-radius: 4px;
    border: 1px solid $color-grey-special;
  }

  &.is-selected {
    box-shadow: 0 0 0 2px $color-accessible-green;

    @include media-breakpoint-up(md) {
      border-radius: 4px;
    }

    .base-block-tmp__inner-wrapper {
      border-radius: 4px;
    }
  }

  .coupon-tag {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0.8rem;

    &__icon {
      fill: $color-red;
      width: 1.5rem;
      margin-right: 0.25rem;
      margin-left: -2px;
    }
  }

  // BUTTONS
  .button--editbutton {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
  }

  .menu-button {
    position: absolute;
    top: 3.25rem;
    right: 0.5rem;
  }

  .base-block-tmp__media .menu-button {
    top: 3rem;
    right: 1.25rem;

    @include media-breakpoint-down(sm) {
      right: 0.75rem;
      top: 3.5rem;
    }
  }

  .save-recipe-button,
  .select-button {
    position: absolute;
    z-index: 1;
    right: 0.5rem;
    top: 0.5rem;
  }

  .base-block-tmp__media .save-recipe-button,
  .base-block-tmp__media .select-button {
    right: 1rem;
    top: 1rem;

    @include media-breakpoint-down(sm) {
      right: 0.75rem;
      top: 0.75rem;
    }
  }

  // MEDIA - PICTURES
  .base-block-tmp__media {
    position: relative;
    order: 1;

    .epi-picture {
      padding: 0.5rem 0.5rem 0.5rem 0;
    }

    a.epi-picture {
      display: block;
    }
  }

  .base-block-tmp__media-lg {
    position: relative;

    .epi-picture {
      padding: 0;
    }

    :not(.base-block-tmp--full) & {
      @include media-breakpoint-only(md) {
        min-height: 13.75rem;
      }

      @include media-breakpoint-up(md) {
        min-height: auto;
      }
    }
  }

  @include media-breakpoint-down(sm) {
    &:not(&--full) .base-block-tmp__media {
      .epi-picture {
        .epi-background-container {
          border-radius: 4px;
        }

        .empty-image-placeholder {
          padding-bottom: 100%;
        }
      }
    }
  }

  .base-block-tmp__content-slot__padding {
    position: relative;
  }

  &__content {
    text-align: left;
    justify-content: start;

    @include media-breakpoint-up(md) {
      .base-block-tmp.base-block-tmp--full & > * {
        justify-content: center;
        text-align: center;
      }
    }

    &__title {
      display: flex;

      .base-block-tmp .base-block-tmp__content-slot & {
        @include font(text, 3, bold);

        color: $color-grey-dark;
      }

      .base-block-tmp.base-block-tmp--full .base-block-tmp__content-slot & {
        @include font(text, 3, bold);

        @include media-breakpoint-up(md) {
          @include font(text, 5, bold);
        }
      }
    }

    &__attr {
      display: flex;
      flex-wrap: wrap;
      color: $color-secondary-text;

      .base-block-tmp--media-right-small & {
        margin-top: 0.25rem;
      }

      > div {
        margin-top: 0.25rem;
        margin-right: 0.5rem;
        display: flex;
        line-height: 1.25rem;

        @include font(text, 2, 'bold');

        .svg-icon {
          height: 1.25rem;
        }
      }

      &__icon {
        height: 1rem;
        width: 1rem;
        fill: $color-secondary-text;

        @include media-breakpoint-down(sm) {
          height: 1.25rem;
        }
      }

      & &__rating {
        margin-left: -0.125rem;
      }

      & &__comments {
        line-height: 1.5rem;

        &--text {
          margin-left: 0.25rem;
        }

        @include media-breakpoint-down(sm) {
          line-height: 1.5rem;
        }
      }

      & &__climate {
        line-height: 1.5rem;
        color: $color-climate;

        .svg-icon {
          fill: $color-climate;
        }

        &--text {
          margin-left: 0.25rem;
        }
      }
    }

    &__preamble {
      @include font(text, 3, normal);
    }
  }
}
</style>
